/* eslint-disable jsx-a11y/media-has-caption */
import * as React from "react";
import { ArtisanContent } from "./ArtisanContent";

export function Artisan() {
  const videoRef = React.useRef(null);
  const [inView, setInView] = React.useState(false);
  const [srcMp4, setSrcMp4] = React.useState(""); 

  // 1) viewport-д ормогц идэвхжүүлнэ
  React.useEffect(() => {
    const el = videoRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  React.useEffect(() => {
    if (!inView) return;
    setSrcMp4("/media/artisan.mp4");
  }, [inView]);

  React.useEffect(() => {
    const v = videoRef.current;
    if (!v || !srcMp4) return;

    v.muted = true; // safety
    v.setAttribute("playsInline", "true");

    v.load();
    const tryPlay = async () => {
      try {
        await v.play();
      } catch (err) {
        console.warn("Autoplay blocked, will wait for user gesture", err);
      }
    };
    const onLoadedMeta = () => tryPlay();
    v.addEventListener("loadedmetadata", onLoadedMeta);

    const onError = (e) => console.error("Video error:", e);
    v.addEventListener("error", onError);

    return () => {
      v.removeEventListener("loadedmetadata", onLoadedMeta);
      v.removeEventListener("error", onError);
    };
  }, [srcMp4]);

  return (
    <div className="flex flex-col text-xl font-light text-white">
      <div className="relative w-full aspect-video max-md:h-[700px] md:aspect-[16/9]">
        <video
          ref={videoRef}
          className="absolute inset-0 w-full h-full object-cover z-0"
          preload="none"
          poster="/media/artisan_poster.jpg"
          autoPlay
          loop
          muted
          playsInline
        >
          {srcMp4 && <source src={srcMp4} type="video/mp4" />}
          Таны браузер видео тоглуулахгүй байна.
        </video>

        <div className="relative z-20 flex justify-center items-center w-full h-full px-20 max-md:px-5">
          <ArtisanContent />
        </div>
        <div className="absolute inset-0  z-10" />
      </div>

      <div className="md:hidden px-5 mt-5">
        <ArtisanContent mobileOnly />
      </div>
    </div>
  );
}
